import { useEffect } from 'react';
import { useDraftEntryStore } from '../../../stores';
import { useAddContentModalStore } from '../store';

// Allows the entry modal to scroll on top of the add content modal.
// See https://github.com/chakra-ui/chakra-ui/issues/7588
//
// Chakra only runs its own scroll lock for the bottom-most modal in the stack, so
// with the entry modal stacked on the add content modal we turn that lock off
// (`blockScrollOnMount`) and lock the body by hand instead. That hand-rolled lock
// only makes sense while both are up: with the add content modal closed the entry
// modal is the bottom-most modal and Chakra locks the page itself.
//
// The lock is deliberately `touch-action: manipulation` rather than `none`. `none`
// also blocks pinch-to-zoom, and since iOS zooms in on its own when a sub-16px
// input is focused, that left the page zoomed with no gesture to undo it (AH-2579).
export const useEntryModalScrollFix = () => {
  const isEntryModalOpen = useDraftEntryStore((state) =>
    Boolean(state.draftEntry)
  );
  const { isOpen: isAddContentModalOpen } = useAddContentModalStore();
  const shouldLockBody = isEntryModalOpen && isAddContentModalOpen;

  useEffect(() => {
    const body = document.body;

    const restore = () => {
      body.style.overflow = '';
      body.style.touchAction = '';
    };

    if (shouldLockBody) {
      body.style.overflow = 'hidden';
      body.style.touchAction = 'manipulation';
    } else {
      restore();
    }

    return () => restore();
  }, [shouldLockBody]);

  return { isEntryModalOpen };
};
